/**
 * Evant Tracking Script
 * Send data to BigQuery
 * @author Abu Sufian
 */

export default{

    /**
     * Get User Browser Language 
     */
    getBrowserlanguage(){
        return (navigator.language) ? navigator.language : getSiteLanguageName();
    },

    /**
     * Get Query Param Value
     * @param {*} name 
     */
    getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' ')) || '';
    },


    /**
     * Produce Unique Browser ID
     * Make It 30 Minuter After Unqiue, add 30 minute timestamp
     * 
     */
    getUniqueBrowserId(){
        var navigator_info = window.navigator;
        var screen_info = window.screen;
        var uid = navigator_info.mimeTypes.length;
        uid += navigator_info.userAgent.replace(/\D+/g, '');
        uid += navigator_info.plugins.length;
        uid += screen_info.height || '';
        uid += screen_info.width || '';
        uid += screen_info.pixelDepth || '';

        return uid;
    },


    /**
     * Create UUID for 1 hour
     * @param {*} cname 
     */
    createOneHourUUID(){
        var date = new Date;
        var hour = date.getHours();
        var year = date.getFullYear();
        var month = date.getMonth(); // beware: January = 0; February = 1, etc.
        var day = date.getDate();

        return year.toString() + month.toString() + day.toString() + hour.toString();
    },


    /**
     * Get Cookies by Name
     * @param {*} cname 
     */
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return "";
    }

}



// WEBPACK FOOTER //
// ./src/utils/event_tracker.js